import { customerBusiness } from "api/bussiness/customer/customer-bussiness";
import {
  createCustomerDependentPagedAutoCompleteMetaData,
  createDomainPagedAutoCompleteMetaData,
} from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IForm } from "commons/ultilities/dynamic-form/models/form";
import { numberNanable } from "commons/ultilities/validation";
import { cloneDeep } from "lodash";
import {
  IAddQuotation,
  IUpdateQuotation,
} from "mobx-stores/_models/quotation/quotation";
import { date, number, string } from "yup";
export const getAddQuotationFormSchema = (
  form: IForm,
): ObjectSchemaType<IAddQuotation> => {
  const resolveCustomerId = () => form?.getControl("customerId").value ?? null;

  return {
    date: {
      gridSize: 6,
      label: "Ngày",
      type: InputType.datePicker,
      validattionYupSchema: date().required(),
    },

    customerId: {
      type: InputType.autoComplete,
      gridSize: 6,
      label: "Tên giao dịch",
      validattionYupSchema: string().required(),
      metaData: createDomainPagedAutoCompleteMetaData("customer"),
    },
    deliveryAddressId: {
      type: InputType.autoComplete,
      gridSize: 6,
      label: "Địa chỉ giao hàng",
      validattionYupSchema: string().required(),
      metaData: {
        searchOptionItemsAsync: async () => {
          const customerId = resolveCustomerId();
          if (!customerId) return [];
          return await customerBusiness.getDeliveryAddressByCustomerAsOptionItems(
            customerId,
          );
        },
      },
    },
    receiverInfo: {
      type: InputType.text,
      gridSize: 6,
      label: "Người nhận",
      validattionYupSchema: string().max(256),
    },
    note: {
      type: InputType.textArea,
      gridSize: 12,
      label: "Ghi chú",
      validattionYupSchema: string().max(256),
    },
    items: {
      label: "Chi tiết phiếu báo giá",
      type: InputType.array,
      arraySchema: {
        productId: {
          label: "Mặt hàng",
          gridSize: 3,
          type: InputType.autoComplete,
          validattionYupSchema: string().required(),
          metaData: createCustomerDependentPagedAutoCompleteMetaData(
            "product",
            resolveCustomerId,
          ),
          defaultValue: "",
        },
        amount: {
          label: "SL đặt",
          gridSize: 1,
          type: InputType.number,
          validattionYupSchema: number().required().min(0),
          defaultValue: 0,
        },
        unitPrice: {
          label: "Đơn giá",
          gridSize: 1,
          type: InputType.number,
          validattionYupSchema: number().required().min(0),
          defaultValue: 0,
        },
        note: {
          label: "Ghi chú",
          gridSize: 2,
          type: InputType.text,
          validattionYupSchema: string().max(512),
          defaultValue: "",
        },
        oldUnitPriceDateFirst: {
          label: "Đơn giá cũ 1 - Ngày",
          gridSize: 1.5,
          type: InputType.datePicker,
          validattionYupSchema: date().nullable(),
        },
        oldUnitPriceFirst: {
          label: "Đơn giá cũ 1",
          gridSize: 1,
          type: InputType.number,
          validattionYupSchema: numberNanable(),
        },
        oldUnitPriceDateSecond: {
          label: "Đơn giá cũ 2 - Ngày",
          gridSize: 1.5,
          type: InputType.datePicker,
          validattionYupSchema: date().nullable(),
        },
        oldUnitPriceSecond: {
          label: "Đơn giá cũ 2",
          gridSize: 1,
          type: InputType.number,
          validattionYupSchema: numberNanable(),
        },
      },
    },
  };
};

export const getEditQuotationFormSchema = (
  form: IForm,
): ObjectSchemaType<IUpdateQuotation> => {
  const schema = getAddQuotationFormSchema(form);
  const updateSchema: ObjectSchemaType<IUpdateQuotation> = cloneDeep(schema);
  updateSchema.id = {
    type: InputType.none,
  };
  updateSchema.items.arraySchema.id = {
    type: InputType.none,
  };

  return updateSchema;
};
